<template>
  <div v-if="impersonatingReseller" class="bg-red-700 text-white" :class="IMPERSONATION_BANNER_HEIGHT_CLASS">
    <div class="max-w-10xl mx-auto flex h-full items-center justify-between gap-3 px-4">
      <p class="flex items-center gap-2 min-w-0 text-sm">
        <UserIcon class="h-4 w-4 shrink-0 text-red-200" />
        <span class="uppercase tracking-widest text-[11px] font-bold text-red-200 shrink-0">Acting as</span>
        <span class="font-semibold truncate">{{ actingAsName }}</span>
      </p>
      <button
        class="shrink-0 rounded-full border border-white/50 px-3 py-1 text-xs font-semibold uppercase tracking-wide transition-colors duration-150 hover:bg-white hover:text-red-700"
        @click="exit"
      >
        Back to Reseller Hub
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { UserIcon } from '@heroicons/vue/outline'
import { IMPERSONATION_BANNER_HEIGHT_CLASS } from '@/components/Reseller/impersonationBannerHeight'

export default {
  name: 'ImpersonationBanner',
  components: { UserIcon },
  data() {
    return { IMPERSONATION_BANNER_HEIGHT_CLASS }
  },
  computed: {
    ...mapGetters(['impersonatingReseller', 'customer']),
    actingAsName() {
      return this.customer?.attributes?.display_user_name || this.customer?.attributes?.phone_number?.formatted || '...'
    }
  },
  methods: {
    async exit() {
      const restored = this.$store.dispatch('exitResellerImpersonation')
      await restored
      await this.$store.dispatch('getCustomerInfo', undefined)
      this.$router.push('/resellers')
    }
  }
}
</script>
